import React, { useEffect } from 'react'
import { BODY_PARTS } from '../../../constants'
import { ListItemContent } from '../../../components/display/ListItemContent'
import { useStaggerFadeIn } from '../../../components/animation/useFadeIn'

const BLINDED = 'BLINDED'
export const EligibilityTable = ({ data, mutateEligibility }) => {
  console.log('🚀 = EligibilityTable = data:', data)
  useEffect(() => {
    return () => {
      mutateEligibility()
    }
  }, [mutateEligibility])

  const calculation = data?.viewCalculation
  const eligibility = data.eligibility

  return (
    <div className="">
      <div className="col-12 px-2">
        <div className="row">
          <div className="col-12 border rounded-2 mt-2">
            <div className="row px-2 py-3 border-bottom" style={{ marginTop: 0, background: '#f8f8f8' }}>
              <div className="col-2 d-flex align-items-center p-small lh-sm">Bodypart</div>
              <div className="col-1 px-0 d-flex justify-content-center align-items-center text-center p-small lh-sm">
                Days in Phase
              </div>
              <div className="col-2 d-flex justify-content-center align-items-center p-small lh-sm">Answers</div>

              <div className="col-2 d-flex justify-content-center text-center p-small lh-sm">
                Average
                <br />
                daily pain
              </div>
              <div className="col-2 d-flex justify-content-center p-small lh-sm">
                Standard
                <br />
                Deviation
              </div>

              <div className="col-2 d-flex justify-content-center text-center p-small lh-sm">
                NPRS out
                <br />
                of range
              </div>
              <div className="col-1 d-flex justify-content-center text-center p-small lh-sm align-items-center">
                Eligible
              </div>
            </div>
            {calculation &&
              calculation.map((item, index) => {
                const validDeviation =
                  (item.deviation >= eligibility.deviationMin && item.deviation <= eligibility.deviationMax) ||
                  item.deviation === BLINDED

                //
                // We check value aginst eligibility configuration to see if it's valid
                // We also need to check if the value is set to BLINDED
                //
                const validAverage =
                  (item.mean >= eligibility.averageMin && item.mean <= eligibility.averageMax) ||
                  item.deviation === BLINDED

                // if amount of answers is less than minDays, it is invalid
                const validAnswerAmount = eligibility.minDays <= Number(item.valuesCount)
                //const answerAmount = validAnswerAmount && item.values !== BLINDED ? item.values.length : BLINDED

                const answerCount = item.valuesCount

                const bodypartLabel = BODY_PARTS[item.bodypart] || item.bodypart
                const daysInStudy = data?.daysInStudy ? data.daysInStudy : 'N/A'

                const validExclusionValue = item?.exclusionValues && item?.exclusionValues?.length !== 0
                const exclusionValue = validExclusionValue ? item.exclusionValues.toString() : 'N/A'

                const eligible = item?.eligible === true ? 'Yes' : 'No'
                const eligibleValue = item?.eligible === BLINDED ? BLINDED : eligible

                return (
                  <div key={index} className="row p-2 border-bottom" style={{ marginTop: 0 }}>
                    <div className="col-2 border-end d-flex ">{bodypartLabel}</div>
                    <div className="col-1 border-end d-flex justify-content-center">
                      <p className={daysInStudy ? '' : 'text-danger fw-bold'}>{daysInStudy}</p>
                    </div>
                    <div className="col-2 border-end d-flex justify-content-center">
                      <p className={handleRed({ value: answerCount, isValid: validAnswerAmount })}>{answerCount}</p>
                    </div>
                    <div className="col-2 border-end d-flex justify-content-center">
                      <p className={handleRed({ value: item.mean, isValid: validAverage })}> {item.mean}</p>
                    </div>
                    <div className="col-2 border-end d-flex justify-content-center">
                      <p className={handleRed({ value: item.deviation, isValid: validDeviation })}> {item.deviation}</p>
                    </div>

                    <div className="col-2 border-end  d-flex justify-content-center ">
                      <p
                        className={handleRed({
                          value: exclusionValue,
                          force: validExclusionValue,
                        })}
                      >
                        {exclusionValue}
                      </p>
                    </div>

                    <div className="col-1 d-flex justify-content-center">
                      <p className={handleRed({ value: eligibleValue })}>{eligibleValue}</p>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

const handleRed = ({ value, isValid = true, force = false }) => {
  if (value === BLINDED) return ''
  if (force) return 'text-danger fw-bold'
  return isValid ? '' : 'text-danger fw-bold'
}
/**
 *
 * THis component is only for viewing the eligibility data
 *
 *
 * @param data
 * @constructor
 */
export const EligibilityAssementView = ({ data }) => {
  console.log('🚀 = EligibilityAssementView = data:', data)
  const calculation = data?.assessmentCalculation
  const daysInStudy = data?.daysInStudy ? data.daysInStudy : 'N/A'

  return (
    <div className="col-12 px-2">
      {calculation &&
        calculation.map((item, index) => {
          return (
            <AssementItem
              key={index}
              item={item}
              eligibility={data.eligibility}
              daysInStudy={daysInStudy}
              index={index}
            ></AssementItem>
          )
        })}
    </div>
  )
}

const AssementItem = ({ item, daysInStudy, eligibility, index }) => {
  const bodypartLabel = BODY_PARTS[item.bodypart] || item.bodypart
  const bodypartBlinded = bodypartLabel === BLINDED

  const daysLabel = daysInStudy === 1 ? daysInStudy.toString() + 'day' : daysInStudy.toString() + ' days'

  const { animated, spring } = useStaggerFadeIn(index)
  //const averageBlinded = item.mean === BLINDED
  //const validAverage = (item.mean >= eligibility.averageMin && item.mean <= eligibility.averageMax) || averageBlinded

  //const deviationBlinded = item.deviation === BLINDED
  /* const validDeviation =
    (item.deviation >= eligibility.deviationMin && item.deviation <= eligibility.deviationMax) || deviationBlinded*/

  const valuesCount = item.valuesCount

  const validAnswerAmount = eligibility.minDays <= Number(item.valuesCount) || valuesCount

  const eligibleBlinded = item?.eligible === BLINDED
  const eligible = item?.eligible === true ? 'Yes' : 'No'
  const eligibleValue = eligibleBlinded ? BLINDED : eligible

  const elWidth = '25%' // `${(100 / 6).toFixed(2)}%`

  return (
    <animated.div
      className="bg-white d-flex justify-content-between align-items-center py-3 px-3 mb-2 flex-wrap "
      style={{
        borderBottom: '1px solid ',
        borderBottomColor: '#e4e4e4',
        boxShadow: '0px 4px 8px -5px rgba(0, 0, 0, 0.1)',
        ...spring,
      }}
    >
      <ListItemContent
        label="Bodypart"
        title={bodypartLabel}
        capitalizeText={bodypartBlinded ? false : true}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>

      <ListItemContent
        label="Days in Phase"
        type={daysInStudy ? '' : 'danger'}
        title={daysLabel}
        capitalizeText={true}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>

      {/* <ListItemContent
        label="Average daily pain"
        type={validAverage ? '' : 'danger'}
        title={item.mean}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>

      <ListItemContent
        type={validDeviation ? '' : 'danger'}
        label="Std. Deviation"
        title={item.deviation}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>*/}

      <ListItemContent
        type={validAnswerAmount ? '' : 'danger'}
        label="Answers:"
        title={valuesCount}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>

      <ListItemContent
        label="Eligible"
        type={daysInStudy ? '' : 'danger'}
        title={eligibleValue}
        capitalizeText={eligibleBlinded ? false : true}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>

      {/*{bodypartBlinded ? null : (
        <ListItemContent
          label="Bodypart"
          title={bodypartLabel}
          capitalizeText={true}
          style={{ width: elWidth.toString() }}
        ></ListItemContent>
      )}

      {averageBlinded ? null : (
        <ListItemContent
          label="Average daily pain"
          type={validAverage ? '' : 'danger'}
          title={item.mean}
          style={{ width: elWidth.toString() }}
        ></ListItemContent>
      )}

      {deviationBlinded ? null : (
        <ListItemContent
          type={validDeviation ? '' : 'danger'}
          label="Std. Deviation"
          title={item.deviation}
          style={{ width: elWidth.toString() }}
        ></ListItemContent>
      )}

      {answerBlined ? null : (
        <ListItemContent
          type={validAnswerAmount ? '' : 'danger'}
          label="Answers:"
          title={values}
          style={{ width: elWidth.toString() }}
        ></ListItemContent>
      )}

      <ListItemContent
        label="In phase"
        type={daysInStudy ? '' : 'danger'}
        title={daysLabel}
        capitalizeText={true}
        style={{ width: elWidth.toString() }}
      ></ListItemContent>
      {eligibleBlinded ? null : (
        <ListItemContent
          label="Eligible"
          type={daysInStudy ? '' : 'danger'}
          title={eligible}
          capitalizeText={true}
          style={{ width: elWidth.toString() }}
        ></ListItemContent>
      )}*/}
    </animated.div>
  )
}
